import Vue from 'vue';
import Component from 'vue-class-component';
import optimizeImage from 'common/utils/optimizeImage';

@Component({
  props: {
    images: {
      type: Array,
      required: true,
    },
    borderColor: {
      type: String,
      description:
        'The thumbnails have different borders color depending of the view the carousel is in',
      required: true,
    },
    showGradient: {
      type: Boolean,
      default: false,
    },
    showThumbnails: {
      type: Boolean,
      default: true,
    },
    showPreview: {
      type: Boolean,
      default: true,
    },
    showDots: {
      type: Boolean,
      default: false,
    },
    backgroundSize: {
      type: String,
      default: 'cover',
    },
    imageSize: {
      type: String,
      default: 'full-size',
    },
    isExperiencePreview: {
      type: Boolean,
      default: false,
    },
  },
})
export default class NewCarouselComponent extends Vue {
  imgShowing = 0;
  imgInModal = 0;
  modalOpened = false;
  swipePositionStart = {};

  optimized(imageUrl) {
    const isVideo = imageUrl.slice(-3).toLowerCase() === 'mp4';
    if (isVideo) {
      return imageUrl;
    }
    return optimizeImage(imageUrl, '768');
  }

  handleStart(e) {
    this.swipePositionStart.x = e.changedTouches[0].screenX;
    this.swipePositionStart.y = e.changedTouches[0].screenY;
  }

  handleEnd(e) {
    if (this.images.length > 1) {
      const swipeXDiff =
        this.swipePositionStart.x - e.changedTouches[0].screenX;
      const swipeYDiff =
        this.swipePositionStart.y - e.changedTouches[0].screenY;

      if (Math.abs(swipeXDiff) > Math.abs(swipeYDiff)) {
        if (swipeXDiff > 0) {
          if (this.modalOpened) {
            this.nextImageModal();
          } else {
            this.nextImageMain();
          }
        } else if (this.modalOpened) {
          this.prevImageModal();
        } else {
          this.prevImageMain();
        }
      }
    }
  }

  changeModalStatus() {
    if (this.images.length > 1 && !this.isExperiencePreview) {
      this.modalOpened = !this.modalOpened;
      // document.querySelector('.baseView').style.overflow = this.modalOpened ? 'hidden' : 'initial';
      this.$emit('modalOpened', this.modalOpened);
    }
  }

  prevImageMain() {
    this.imgShowing =
      this.imgShowing !== 0 ? this.imgShowing - 1 : this.images.length - 1;
  }

  nextImageMain() {
    this.imgShowing =
      this.imgShowing !== this.images.length - 1 ? this.imgShowing + 1 : 0;
  }

  prevImageModal() {
    this.imgInModal =
      this.imgInModal !== 0 ? this.imgInModal - 1 : this.images.length - 1;
  }

  nextImageModal() {
    this.imgInModal =
      this.imgInModal !== this.images.length - 1 ? this.imgInModal + 1 : 0;
  }
}
